module.exports = __webpack_public_path__ + "static/event2-6f47f20490a2d3f3d34bae282adde24e.jpg";